

export function ToggleRow({ label, sublabel, on, disabled, busy, indent, onToggle }: {
  label: string; sublabel: string; on: boolean; disabled: boolean; busy: boolean; indent?: boolean; onToggle: () => void
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingLeft: indent ? 16 : 0 }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '0.85rem', color: 'var(--text)' }}>{label}</div>
        <div style={{ fontSize: '0.72rem', color: 'var(--text3)', marginTop: 2 }}>{sublabel}</div>
      </div>
      <span className={on ? 'badge badge-green' : 'badge badge-neutral'} style={{ fontSize: '0.65rem' }}>
        {on ? 'enabled' : 'disabled'}
      </span>
      <button className="btn btn-ghost btn-sm" disabled={disabled} onClick={onToggle}>
        {busy ? <span className="spinner" /> : (on ? 'Disable' : 'Enable')}
      </button>
    </div>
  )
}
